interface IPittaRem {
  account: string;
  /**
   * Absolute Unix timestamp (seconds) used to compute the cookie's `Expires`
   * attribute. Convert the backend's `expires_in` (a duration) via
   * `now + expires_in` before passing it here.
   */
  expiresAt?: number;
}

export const parseCookie = (): Record<string, string> => {
  const cookieObj: Record<string, string> = {};
  if (!document.cookie) {
    return cookieObj;
  }
  for (const part of document.cookie.split('; ')) {
    const [rawName, ...rawValue] = part.split('=');
    if (!rawName) {
      continue;
    }
    try {
      cookieObj[decodeURIComponent(rawName)] = decodeURIComponent(rawValue.join('='));
    } catch {
      cookieObj[rawName] = rawValue.join('=');
    }
  }
  return cookieObj;
};

export const getPittaRem = (): IPittaRem | null => {
  const cookies = parseCookie();
  const raw = cookies?.pitta_rem;
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw) as IPittaRem;
  } catch {
    return null;
  }
};

export const setPittaRem = ({ account, expiresAt }: IPittaRem): void => {
  const expires = expiresAt ? new Date(expiresAt * 1000).toUTCString() : '';
  const payload = encodeURIComponent(JSON.stringify({ account }));
  const isHttps = typeof window !== 'undefined' && window.location.protocol === 'https:';
  const attrs = [
    `pitta_rem=${payload}`,
    expires && `expires=${expires}`,
    'path=/',
    'SameSite=Lax',
    isHttps && 'Secure',
  ]
    .filter(Boolean)
    .join('; ');
  document.cookie = attrs;
};
